import { lazy, Suspense } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'

// Lazy load all surfaces for code splitting
const PortfolioProofSystem = lazy(() => import('@surfaces/portfolio/PortfolioProofSystem'))
const PortfolioMetricsDashboard = lazy(() => import('@surfaces/portfolio/PortfolioMetricsDashboard'))
const PortfolioRegistryView = lazy(() => import('@surfaces/portfolio/PortfolioRegistryView'))
const PortfolioFamilyMap = lazy(() => import('@surfaces/portfolio/PortfolioFamilyMap'))
const PortfolioPendingRulings = lazy(() => import('@surfaces/portfolio/PortfolioPendingRulings'))

const WritingStoneCommandCenter = lazy(() => import('@surfaces/writing-stone/WritingStoneCommandCenter'))
const EntityAliasLedger = lazy(() => import('@surfaces/writing-stone/EntityAliasLedger'))
const TimelineBuilder = lazy(() => import('@surfaces/writing-stone/TimelineBuilder'))
const ContinuityCourt = lazy(() => import('@surfaces/writing-stone/ContinuityCourt'))
const WS004SequenceView = lazy(() => import('@surfaces/writing-stone/WS004SequenceView'))

const JobCommandCenter = lazy(() => import('@surfaces/jobs/JobCommandCenter'))
const RoleScoreDashboard = lazy(() => import('@surfaces/jobs/RoleScoreDashboard'))
const RecruiterCRM = lazy(() => import('@surfaces/jobs/RecruiterCRM'))
const ResumeKeywordMatrix = lazy(() => import('@surfaces/jobs/ResumeKeywordMatrix'))

const EvidenceRecoveryCockpit = lazy(() => import('@surfaces/evidence/EvidenceRecoveryCockpit'))
const EvidenceChronologyTable = lazy(() => import('@surfaces/evidence/EvidenceChronologyTable'))
const RawRecoveryQueue = lazy(() => import('@surfaces/evidence/RawRecoveryQueue'))
const EvidenceBadgeReference = lazy(() => import('@surfaces/evidence/EvidenceBadgeReference'))

const ArkRegistryDashboard = lazy(() => import('@surfaces/registry/ArkRegistryDashboard'))
const OpenClawStagingMap = lazy(() => import('@surfaces/registry/OpenClawStagingMap'))
const AliasTracker = lazy(() => import('@surfaces/registry/AliasTracker'))

const NotebookLMAuditLauncher = lazy(() => import('@surfaces/notebooklm/NotebookLMAuditLauncher'))
const AuditNotebookMap = lazy(() => import('@surfaces/notebooklm/AuditNotebookMap'))
const AuditFindingTracker = lazy(() => import('@surfaces/notebooklm/AuditFindingTracker'))

function SurfaceLoader() {
  return (
    <div className="h-full w-full flex items-center justify-center">
      <div className="flex flex-col items-center gap-3">
        <div className="w-8 h-8 border-2 border-ark-gold/30 border-t-ark-gold rounded-full animate-spin" />
        <span className="text-xs text-ark-text-dim font-mono uppercase tracking-wider">Loading Surface...</span>
      </div>
    </div>
  )
}

export function AppRoutes() {
  return (
    <Suspense fallback={<SurfaceLoader />}>
      <Routes>
        {/* Portfolio Surface */}
        <Route path="/portfolio" element={<PortfolioProofSystem />} />
        <Route path="/portfolio/metrics" element={<PortfolioMetricsDashboard />} />
        <Route path="/portfolio/registry" element={<PortfolioRegistryView />} />
        <Route path="/portfolio/family-map" element={<PortfolioFamilyMap />} />
        <Route path="/portfolio/pending-rulings" element={<PortfolioPendingRulings />} />

        {/* Writing Stone Surface */}
        <Route path="/writing-stone" element={<WritingStoneCommandCenter />} />
        <Route path="/writing-stone/alias-ledger" element={<EntityAliasLedger />} />
        <Route path="/writing-stone/timeline" element={<TimelineBuilder />} />
        <Route path="/writing-stone/continuity-court" element={<ContinuityCourt />} />
        <Route path="/writing-stone/ws004-sequence" element={<WS004SequenceView />} />

        {/* Jobs Surface */}
        <Route path="/jobs" element={<JobCommandCenter />} />
        <Route path="/jobs/role-scores" element={<RoleScoreDashboard />} />
        <Route path="/jobs/recruiter-crm" element={<RecruiterCRM />} />
        <Route path="/jobs/keyword-matrix" element={<ResumeKeywordMatrix />} />

        {/* Evidence Surface */}
        <Route path="/evidence" element={<EvidenceRecoveryCockpit />} />
        <Route path="/evidence/chronology" element={<EvidenceChronologyTable />} />
        <Route path="/evidence/recovery-queue" element={<RawRecoveryQueue />} />
        <Route path="/evidence/badge-reference" element={<EvidenceBadgeReference />} />

        {/* Registry Surface */}
        <Route path="/registry" element={<ArkRegistryDashboard />} />
        <Route path="/registry/openclaw-staging" element={<OpenClawStagingMap />} />
        <Route path="/registry/alias-tracker" element={<AliasTracker />} />

        {/* NotebookLM Surface */}
        <Route path="/notebooklm" element={<NotebookLMAuditLauncher />} />
        <Route path="/notebooklm/notebook-map" element={<AuditNotebookMap />} />
        <Route path="/notebooklm/findings" element={<AuditFindingTracker />} />

        {/* Default redirect */}
        <Route path="/" element={<Navigate to="/portfolio" replace />} />
        <Route path="*" element={<Navigate to="/portfolio" replace />} />
      </Routes>
    </Suspense>
  )
}
